import moment from 'moment';

const NETWORK_ONLINE_TYPE = 'online';
const PAGE_HIDDEN_THRESHOLD = 900000; // 15 minutes

export default class HealthChecker {
    /** @ngInject */
    constructor($window, $rootScope) {
        this.$window = $window;
        this.$rootScope = $rootScope;

        this.pageHiddenAt = null;

        this.networkStatusUpdated = this.networkStatusUpdated.bind(this);
        this.visibilityChanged = this.visibilityChanged.bind(this);
    }

    networkStatusUpdated({ type }) {
        if (type === NETWORK_ONLINE_TYPE) {
            this.$rootScope.$broadcast('health-checker-network-up');
        }

        this.$rootScope.$applyAsync();
    }

    visibilityChanged() {
        if (document.hidden) {
            this.pageHiddenAt = moment();
        } else if (this.pageHiddenAt && moment().diff(this.pageHiddenAt) > PAGE_HIDDEN_THRESHOLD) {
            this.$rootScope.$broadcast('health-checker-page-visible');
        }

        this.$rootScope.$applyAsync();
    }

    initTracking() {
        this.$window.addEventListener('online', this.networkStatusUpdated);
        this.$window.addEventListener('offline', this.networkStatusUpdated);
        this.$window.addEventListener('visibilitychange', this.visibilityChanged);
    }
}



// WEBPACK FOOTER //
// ./app/services/health-checker/health-checker.service.js